import { Box, Container, FormControlLabel, FormGroup, Grid, Switch, Typography } from "@mui/material";
import React, { Component } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer(props) {

    const location = useLocation();

    let path = "";
    let parts = location.pathname.split('/');

    if (parts.length === 3) {
        path = ".";
    }

    const [checked, setChecked] = React.useState(props.darkMode);

    const handleChange = (event) => {
        setChecked(event.target.checked);
        props.setDarkMode(event.target.checked)
    };

    let background = props.darkMode
        ? props.theme.palette.grey[800]
        : props.theme.palette.grey[400];

    return (
        <Box
            component="footer"
            sx={{
                py: 3,
                px: 2,
                mt: 'auto',
                backgroundColor: background
            }}
        >
            <Container>
                <Grid item sx={{ mb: "20px" }}>
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item sx={{ marginLeft: "20px", marginRight: "20px" }}>
                            <Grid container alignItems="center">
                                <a href="https://www.spelinspektionen.se/"><img alt="Plus 18" src={path + "./images/18.png"} height="40px"></img></a>
                            </Grid>
                        </Grid>
                        <Grid item sx={{ marginLeft: "20px", marginRight: "20px" }}>
                            <Grid container alignItems="center">
                                <a href="https://stodlinjen.se/"><img alt="Stödlinjen" src={path + "./images/stodlinjen.png"} height="40px"></img></a>
                            </Grid>
                        </Grid>

                        <Grid item sx={{ marginLeft: "20px", marginRight: "20px" }}>
                            <Grid container alignItems="center">
                                <a href="https://www.spelinspektionen.se/"><img alt="Spelinspektionen" src={path + "./images/spelinspektionen.png"} height="40px"></img></a>
                            </Grid>
                        </Grid>
                        <Grid item sx={{ marginLeft: "20px", marginRight: "20px" }}>
                            <Grid container alignItems="center">
                                <a href="https://spelpaus.se/"><img alt="Spelpaus" src={path + "./images/spelpaus.png"} height="40px"></img></a>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container flexDirection="row" alignItems="center" justifyContent="space-around">
                        <Grid item alignItems="center">
                            <FormGroup>
                                <FormControlLabel control={<Switch
                                    checked={checked}
                                    onChange={handleChange}
                                />} label="Dark mode" />
                            </FormGroup>
                        </Grid>
                        <Grid item alignItems="center">
                            <Link to="/terms">Användarvillkor</Link>
                        </Grid>
                        <Grid item alignItems="center">
                            <a href="mailto:info@spelvinnare.se">info@spelvinnare.se</a>
                        </Grid>
                    </Grid>
                </Grid>
                <br></br>
                <Copyright />
            </Container>
        </Box>)
};

export class Copyright extends Component {
    render() {
        return (
            <Typography variant="body2" color="text.secondary" align="center">
                {'Copyright © '}
                BAMM Communication AB
                {' ' + new Date().getFullYear()}
            </Typography>
        );
    }
}